module.exports = __webpack_public_path__ + "img/dacheng.b7603c8f.png";